import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    UNDELETE_OPTIONS,
    GET_OPTIONS_SUCCESS,
    UNDELETE_OPTIONS_ERROR,
}
    from "../../../actions/menu/options";

function* unDeleteOptionsSaga(action) {
    try {
        yield call(optionService.UnDeleteOptions, action.payload)
        yield put({
            type: GET_OPTIONS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_OPTIONS_ERROR,error: error.data
        });
    }
}


export function* unDeleteOptionsSagaWatcher() {
    yield takeLatest(UNDELETE_OPTIONS, unDeleteOptionsSaga);
}